/**
 * @generated SignedSource<<e4492d9f1c6b860c521ac26557148d5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCheckoutPixAutomaticForm_checkout$data = {
  readonly customFields: ReadonlyArray<{
    readonly required: boolean | null | undefined;
    readonly title: string;
    readonly type: string;
  } | null | undefined> | null | undefined;
  readonly dynamicValue: boolean | null | undefined;
  readonly id: string;
  readonly minimumValue: number | null | undefined;
  readonly " $fragmentType": "PaymentCheckoutPixAutomaticForm_checkout";
};
export type PaymentCheckoutPixAutomaticForm_checkout$key = {
  readonly " $data"?: PaymentCheckoutPixAutomaticForm_checkout$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutPixAutomaticForm_checkout">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCheckoutPixAutomaticForm_checkout",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dynamicValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minimumValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CheckoutCustomFields",
      "kind": "LinkedField",
      "name": "customFields",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "required",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Checkout",
  "abstractKey": null
};

(node as any).hash = "1dd91dd5003a6c413ff9202a58d1d924";

export default node;
